import { useTranslation } from 'react-i18next'
import {
    Container,
    Grid
} from '@material-ui/core'
import { SimpleLoading, HeaderHLPure } from '../../pures'
import { ConversationList, SimpleCard } from '../../pures/dashboard'
import { DropDownList } from "@progress/kendo-react-dropdowns"

const HistoryView = (props) => {
    const { dataConversations, chatbotUrl, handleGetPaginatedConversation, isLoadingChangePage, isLoading, monthYearOptions, date, handleChangeDate, searchValue, handleSearchChange } = props
    const { t } = useTranslation('clients-dashboard', { keyPrefix: 'historyScreen' })

    return (
        <div className={"dashboardView"}>
            <Container>
                {
                    isLoading ?
                        <div className='loading' style={{ marginTop: '20%' }}>
                            <SimpleLoading />
                        </div>
                        :
                        <Grid>
                            <Grid item xs={12}>
                                <Grid item xs={12}>
                                    <HeaderHLPure title={t("title")} />
                                </Grid>
                                <Grid item xs={16} md={2} style={{ marginTop: '20px'}}>
                                    <SimpleCard
                                        title={t('usagePeriod')}
                                    >
                                        <DropDownList
                                            id='assistantTone'
                                            name={'assistantTone'}
                                            className="eticket-dropdown-field"
                                            textField="text"
                                            dataItemKey="value"
                                            data={monthYearOptions}
                                            value={monthYearOptions.find(option => option.value === date)}
                                            onChange={handleChangeDate}
                                        />
                                    </SimpleCard>
                                </Grid>
                                <ConversationList dataConversations={dataConversations} t={t} chatbotUrl={chatbotUrl} handleGetPaginatedConversation={handleGetPaginatedConversation} isLoadingChangePage={isLoadingChangePage} searchValue={searchValue} handleSearchChange={handleSearchChange} />
                            </Grid>
                        </Grid>
                }
            </Container >
        </div>
    )
}

export { HistoryView as default }